import { Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'layout-header',
  templateUrl: './header.component.html'
})

export class HeaderComponent implements OnInit {

  constructor(
    private authenService: AuthService,
    private spinner: NgxSpinnerService,
  ) {
   }

   private imagesName:string;
   private customerName:string;

  ngOnInit(): void {
    this.imagesName = localStorage.getItem("customer_id");
    this.customerName = localStorage.getItem("customer_name");
  }

  unAuthen(){
    this.authenService.clearStorage();
  }
}
